define(function (require) {

    var BaseFilterItem = require('web-agent-components/BaseFilterItemViewController');

    var FilterItemCollapsibleViewController = BaseFilterItem.extend({

        LPElementsMap: {
            icon: ".lp_collapsible_icon",
            text: ".list_item_name"
        },
        LPTemplatesFiles: {
            textInputItem: 'LP_filter_item_collapsible.html'
        },

        initialize: function (constructorData) {
            var textInputTemplate = require('web-agent-templates/' + this.LPTemplatesFiles.textInputItem);
            this.value = constructorData.value;
            this.collapseFilterItems = constructorData.collapseFilterItems;
            this.view = this.createView({
                template: textInputTemplate,
                doNotAddChild: true,
                elementType: "div",
                textInjection: {
                    value: this.value,
                    textValue: constructorData.textValue
                }
            });
        },
        events: function () {
            this.bindViewEvent({DOMEvent: "click", selector: this.LPElementsMap.icon, callback: this.selectItem});
        },
        render: function () {

        }
    });

    FilterItemCollapsibleViewController.prototype.setDisableFilterItemViewCallback = function (disableFilterItemViewCallback) {
        this.disableFilterItemViewCallback = disableFilterItemViewCallback;
    };

    FilterItemCollapsibleViewController.prototype.setEnableFilterItemViewCallback = function (enableFilterItemViewCallback) {
        this.enableFilterItemViewCallback = enableFilterItemViewCallback;
    };

    FilterItemCollapsibleViewController.prototype.setScrollTopCallback = function (scrollTopCallback) {
        this.scrollTopCallback = scrollTopCallback;
    };

    FilterItemCollapsibleViewController.prototype.setScrollBottomCallback = function (scrollBottomCallback) {
        this.scrollBottomCallback = scrollBottomCallback;
    };

    FilterItemCollapsibleViewController.prototype.selectItem = function () {
        this.checked = !this.checked;
        this.updateView();
    };

    FilterItemCollapsibleViewController.prototype.updateView = function () {
        var self = this;
        _.each(self.collapseFilterItems, function(filterItem){
            if(!self.checked) {
                if(self.disableFilterItemViewCallback) {
                    self.disableFilterItemViewCallback.call(self, filterItem);
                }
            } else if(self.enableFilterItemViewCallback) {
                self.enableFilterItemViewCallback.call(self, filterItem);
            }
        });

        if(!this.checked) {
            if(this.scrollTopCallback) {
                this.scrollTopCallback.call(this);
            }
        } else if(this.scrollBottomCallback) {
            this.scrollBottomCallback.call(self);
        }
    };

    FilterItemCollapsibleViewController.prototype.getValue = function () {
        return this.checked ? this.value : "";
    };

    FilterItemCollapsibleViewController.prototype.updateFilterUI = function (filterUIData) {
        this.checked = filterUIData === this.value;
        this.updateView();
    };

    return FilterItemCollapsibleViewController;
});
